import { FC, useEffect, useRef, useState } from 'react'

// カスタムStickyコンポーネント
interface StickyProps {
  children: (props: {
    style: React.CSSProperties
    isSticky: boolean
  }) => React.ReactNode
  top?: number
  stickyHeight?: number // 固定の高さを指定する場合
}

export const Sticky: FC<StickyProps> = ({
  children,
  stickyHeight = 72,
  top = 0,
}) => {
  const [isSticky, setIsSticky] = useState(false)
  const stickyRef = useRef<HTMLDivElement>(null)
  const placeholderRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting)
      },
      {
        threshold: 0,
        rootMargin: '-1px 0px 0px 0px',
      },
    )

    if (placeholderRef.current) {
      observer.observe(placeholderRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  const stickyStyle: React.CSSProperties = {
    position: isSticky ? 'fixed' : 'static',
    top,
    left: 0,
    right: 0,
    zIndex: 800,
  }

  return (
    <>
      <div
        ref={placeholderRef}
        style={{ height: isSticky ? `${stickyHeight}px` : '0px' }}
      />
      <div ref={stickyRef} style={stickyStyle}>
        {children({ style: {}, isSticky })}
      </div>
    </>
  )
}

// カスタムStickyContainerコンポーネント
interface StickyContainerProps {
  children: React.ReactNode
}

export const StickyContainer: FC<StickyContainerProps> = ({ children }) => {
  return <div style={{ position: 'relative' }}>{children}</div>
}
